import React, { useState } from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { LabelH3, P } from "@motorata/base-ui.components.atoms.typography";
import Link from "@motorata/next.components.atoms.link";
import Input from "@motorata/base-ui.components.atoms.input";
import { NextImage } from "../common/Image";

const MotoUpCalculatorBlock = () => {
  const [state, setState] = useState("80000");
  return (
    <Wrapper marginTop="S">
      <Box marginBottom="S">
        <NextImage
          priority={true}
          height={39}
          width={150}
          src="/images/logo_mr_kl_white.svg"
          alt="Logo MotoUP"
        />
      </Box>
      <LabelH3 margin="0 0 1rem" color="white">
        Szukasz najlepszego finansowania?
      </LabelH3>
      <P small color="white">
        Skorzystaj z kalkulatora leasingowego i oblicz ratę finansowania całkowicie online!
      </P>
      <StyledGrid>
        <Input
          label="Podaj wartość (brutto)"
          elementType="numeric"
          name="input"
          textAlign="right"
          endAdornment="zł"
          decimalScale={0}
          value={state}
          onChange={({ value }) => setState(value)}
        />
        <Link type="secondary" href="/kalkulator-leasingowy" query={{
          value: state
        }} target="_blank">
          Oblicz ratę
        </Link>
      </StyledGrid>
    </Wrapper>
  );
};

export default MotoUpCalculatorBlock;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
`;

const Wrapper = styled(Box)`
  position: sticky;
  top: 100px;
  padding: ${({ theme }) => theme.space.M};
  background: ${({ theme }) => theme.color.primary};
  border-radius: 10px;
  overflow: hidden;

  &::before {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    left: 0;
    top: 0;
    z-index: 0;
  }

  &::after {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(50%, 50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: ${({ theme }) => theme.space.L};
  }
`;
